// assets/smile-launcher.js
(function () {
  var btn = document.querySelector('[data-smile-launcher]');
  if (!btn) return;

  function sync(open) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-label', open ? 'Close rewards' : 'Open rewards');
  }

  function openPanel() {
    if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
      return window.SmileUI.openPanel();
    }
    window.postMessage({ type: 'smile-ui:open' }, '*');
  }

  function closePanel() {
    if (window.SmileUI && typeof window.SmileUI.closePanel === 'function') {
      return window.SmileUI.closePanel();
    }
    window.postMessage({ type: 'smile-ui:close' }, '*');
  }

  // Toggle on click; Smile will correct us if it refuses
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    var open = btn.getAttribute('aria-expanded') === 'true';
    open ? closePanel() : openPanel();
  });

  function findSmileLauncherContainer() {
    var host = document.getElementById('smile-ui-container');
    if (!host) return null;
    return host.querySelector('.smile-launcher-frame-container') || null;
  }

  function attachObserver(el) {
    // Tag it so you can style position with CSS if you ever want to
    el.classList.add('vibe-smile-launcher-host');

    var update = function () {
      var open = el.classList.contains('smile-launcher-open');
      sync(open);
    };

    update();

    var mo = new MutationObserver(update);
    mo.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  // Wait for Smile to inject its launcher container
  var tries = 0;
  var readyIv = setInterval(function () {
    var container = findSmileLauncherContainer();
    if (container) {
      attachObserver(container);
      clearInterval(readyIv);
    }
    if (++tries > 80) clearInterval(readyIv); // ~20s
  }, 250);

  // Hide Smile's stock launcher (keep it in DOM for class changes)
  var hideIv = setInterval(function () {
    var container = findSmileLauncherContainer();
    if (container) {
      container.style.visibility = 'hidden';
      container.style.pointerEvents = 'none';
      clearInterval(hideIv);
    }
  }, 250);

  // Bonus: hook Smile events if available
  var evtTries = 0;
  var evtIv = setInterval(function () {
    var r = window.SmileUI;
    if (r && typeof r.on === 'function') {
      r.on('panel:opened', function () { sync(true); });
      r.on('panel:closed', function () { sync(false); });
      clearInterval(evtIv);
    }
    if (++evtTries > 40) clearInterval(evtIv);
  }, 250);
})();
